module.exports = __webpack_public_path__ + "f5b6b96088f4b021a4a16016438d319c.svg";